import React from 'react';
import { Stack } from '@mui/material';

import { ParticipantsForm } from './ParticipantsForm';
import { DynamicMultiFieldCard } from '../ReservationDataTab/DynamicMultiFieldCard';
import { useSelector } from 'react-redux';

export const WRReservationDetails = props => {
  const { formik, order } = props;
  const { seasonYear } = useSelector(state => state.app);

  return (
    <Stack direction="column" justifyContent="space-between" m={2} spacing={2}>
      <Stack direction="row" spacing={2} justifyContent="between">
        <ParticipantsForm formik={formik} />
        <DynamicMultiFieldCard
          formik={formik}
          title="Diety i Zajęcia"
          fields={seasonYear == 2025 ? [
            {
              label: 'Diety',
              field: 'wr_diets_json',
              keyName: 'Dieta',
              secondKeyName: 'Liczba osób',
              options: order.diets_choices
            },
            {
              label: 'Zajęcia',
              field: 'wr_activities_json',
              keyName: 'Zajęcie',
              secondKeyName: 'Liczba osób',
              options: order.wr_activities_choices
            }
          ] : [
            {
              label: 'Diety',
              field: 'wr_diets_json',
              keyName: 'Dieta',
              secondKeyName: 'Liczba osób',
              options: order.diets_choices
            }
          ]}
        />
      </Stack>
    </Stack>
  );
};
